var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCoupon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_-_coupon",
    "data-name": "icon - coupon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_217",
    "data-name": "Rectangle 217",
    width: 26,
    height: 26,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2195",
    "data-name": "Path 2195",
    d: "M21.5,18.67H4.5a.8.8,0,0,1-.8-.8V15.236a.731.731,0,0,1,.585-.726,1.537,1.537,0,0,0,0-3.021.731.731,0,0,1-.585-.725V8.129a.8.8,0,0,1,.8-.8h17a.8.8,0,0,1,.8.8v2.635a.73.73,0,0,1-.584.725,1.537,1.537,0,0,0,0,3.021.73.73,0,0,1,.585.726v2.635a.8.8,0,0,1-.8.8M7.92,17.121a.3.3,0,1,1,.6,0v.95H21.5a.2.2,0,0,0,.2-.2V15.236a.136.136,0,0,0-.1-.136,2.138,2.138,0,0,1,0-4.2.135.135,0,0,0,.1-.135V8.129a.2.2,0,0,0-.2-.2H8.52v.95a.3.3,0,0,1-.6,0v-.95H4.5a.2.2,0,0,0-.2.2v2.635a.134.134,0,0,0,.1.135,2.138,2.138,0,0,1,0,4.2.136.136,0,0,0-.1.136v2.635a.2.2,0,0,0,.2.2H7.92Zm.6-2.748V11.626a.3.3,0,0,0-.6,0v2.747a.3.3,0,0,0,.6,0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCoupon);
export default __webpack_public_path__ + "static/media/icon-coupon.f01023c29c3f5f18411946870ac4bb8c.svg";
export { ForwardRef as ReactComponent };